import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["theme", "typography", "color", "textAlign"],
  _excluded2 = ["as", "children"];
import styled, { css } from 'styled-components';
import { getSpaceStyles } from '../../utils/getSpaceStyles';
import { jsx as _jsx } from "react/jsx-runtime";
/**
 * Adds !important to each property of the typography object
 * This can be used for text elements that are not styled directly by the Text component
 *
 * @deprecated Use getTypographyStylesV2 instead
 */
export const getTypographyStyles = (theme, typography) => {
  return css(["font-family:", " !important;font-weight:", " !important;font-size:", " !important;line-height:", " !important;letter-spacing:", " !important;"], theme.typography[typography].fontFamily, theme.typography[typography].fontWeight, theme.typography[typography].fontSize, theme.typography[typography].lineHeight, theme.typography[typography].letterSpacing);
};

/**
 * Adds !important to each property of the typography object
 * This can be used for text elements that are not styled directly by the Text component
 */
export const getTypographyStylesV2 = (theme, typography) => ({
  fontFamily: `${theme.typography[typography].fontFamily} !important`,
  fontWeight: `${theme.typography[typography].fontWeight} !important`,
  fontSize: `${theme.typography[typography].fontSize} !important`,
  lineHeight: `${theme.typography[typography].lineHeight} !important`,
  letterSpacing: `${theme.typography[typography].letterSpacing} !important`
});

// Note: !important is used to override global styles
const TextWrapper = styled.p.withConfig({
  displayName: "Text__TextWrapper",
  componentId: "sc-15dol2a-0"
})(_ref => {
  let {
      theme,
      typography,
      color,
      textAlign
    } = _ref,
    spaceProps = _objectWithoutPropertiesLoose(_ref, _excluded);
  return css(["", " color:", " !important;text-align:", " !important;", ""], getTypographyStyles(theme, typography), color ? theme.color[color] : 'inherit', textAlign, getSpaceStyles(theme, spaceProps));
});
export const Text = _ref2 => {
  let {
      as = 'p',
      children
    } = _ref2,
    props = _objectWithoutPropertiesLoose(_ref2, _excluded2);
  return /*#__PURE__*/_jsx(TextWrapper, Object.assign({
    forwardedAs: as
  }, props, {
    children: children
  }));
};